<template>
    <b-button
        :key="renderKey"
        class="control-button"
        @click="handleClick"
        :disabled="disabled || isLoading"
        size="lg"
        :variant="colorVariant"
        pill
    >
        <slot v-if="!isLoading" />
        <b-spinner 
            label="Loading..." 
            v-if="isLoading"
            class="align-middle">
        </b-spinner>
    </b-button>
</template>
<script>
import colorVariantMixin from '@/components/mixins/colorVariantMixin'
export default {
    name: 'controlButton',
    mixins: [colorVariantMixin],
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        renderKey: {

        }
    },
    methods: {
        handleClick() {
            this.$emit('click')
        }
    }
}
</script>
<style lang="scss">
    .control-button {
        font-weight: bold;
    }
</style>
